/* -------------------------
 * OJ Skate – Größen sortieren
 * ------------------------- */
(function () {
  const SIZE_ORDER = [
    'XXS', 'XS', 'S', 'S/M',
    'M', 'M/L',
    'L', 'L/XL',
    'XL', 'XXL', '2XL', '3XL', '4XL', '5XL',
    'OS', 'O/S', 'ONE SIZE', 'ONESIZE'
  ];

  function getSizeRank(value) {
    if (!value) return Infinity;

    const val = String(value).trim().toUpperCase();
    const textRank = SIZE_ORDER.indexOf(val);

    if (textRank !== -1) return textRank;

    const numericValue = parseFloat(val.replace(',', '.'));

    if (!isNaN(numericValue)) {
      return 1000 + numericValue;
    }

    return Infinity;
  }

  function sortSizes() {
    const fieldsets = document.querySelectorAll('fieldset[data-handle="grosse"]');

    fieldsets.forEach((fieldset) => {
      const items = Array.from(fieldset.querySelectorAll('.variant-input'));

      if (items.length < 2) return;

      const sortedItems = items.slice().sort((a, b) => {
        return getSizeRank(a.dataset.value) - getSizeRank(b.dataset.value);
      });

      const signature = sortedItems
        .map((item) => item.dataset.value || '')
        .join('|');

      if (fieldset.dataset.sortedSignature === signature) return;

      sortedItems.forEach((item) => {
        fieldset.appendChild(item);
      });

      fieldset.dataset.sortedSignature = signature;
    });
  }

  document.addEventListener('DOMContentLoaded', sortSizes);
  document.addEventListener('variant:changed', sortSizes);
  document.addEventListener('shopify:section:load', sortSizes);

  const observer = new MutationObserver(() => {
    window.requestAnimationFrame(sortSizes);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();